import React from 'react';
import { STATIC_URLS, URLS } from 'services/urls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserCircle, faGrip, faLifeRing, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons';
import { DropdownMenu, DropdownItem } from 'reactstrap';
import './UserMenuItems.scss';
import { useAuth0TokenContext } from 'contexts/Auth0TokenContext';
import useAuthContext from 'contexts/AuthContext';
import { getUserSpecificSelectedOrgKey, USER_CLASSES } from 'services/constants';
import { removeCookie } from 'helpers/localStorage/cookies';
import { IAuthenticatedUser } from '../../../../../queries/UserMenu/useGetAuthenticatedUser';
import useClearDataOnLogout from '../hooks/useClearDataOnLogout';

export interface IProps {
    authenticatedUser?: IAuthenticatedUser
}

const UserMenuItems = ({ authenticatedUser }: IProps) => {
    const { logout: logoutFromTokenContext } = useAuth0TokenContext();

    const { role, isLoadingAuthData, hasDevelopmentAccess } = useAuthContext();

    const showSupportLink = isLoadingAuthData || hasDevelopmentAccess;

    let displayRole = role?.name || 'No Role';
    // a super admin user class supersedes role in auth checks
    if (authenticatedUser?.user.userClass === USER_CLASSES.SUPER_ADMIN) {
        displayRole = authenticatedUser?.user.userClassData.name;
    }

    const { mutate: clearDataOnLogout } = useClearDataOnLogout();

    const handleLogout = () => {
        clearDataOnLogout(undefined, {
            onError: err => {
                console.error('Logout failed:', err);
            },
        });
        if (authenticatedUser) {
            removeCookie(getUserSpecificSelectedOrgKey(authenticatedUser.user.id));
        }
        logoutFromTokenContext({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };

    return (
        <DropdownMenu className="UserMenuItems-dropdown-menu" data-testid="dropdown-menu">
            <DropdownItem header className="text-wrap">
                {authenticatedUser?.user.name}
                {' '}
                {' | '}
                {' '}
                {displayRole}
            </DropdownItem>
            <DropdownItem header className="UserMenuItems-dropdown-menu__dropdown-email">
                {authenticatedUser?.user.email}
            </DropdownItem>
            <DropdownItem divider />

            <a href={URLS.PROJECTS_APP.USER_SETTINGS}>
                <DropdownItem className="d-flex align-items-center py-1 px-2">
                    <FontAwesomeIcon className="mr-1" icon={faUserCircle} size="sm" />
                    Settings
                </DropdownItem>
            </a>

            <a href={URLS.PROJECTS_APP.ORGANIZATION_MANAGEMENT}>
                <DropdownItem className="d-flex align-items-center py-1 px-2">
                    <FontAwesomeIcon className="mr-1" icon={faGrip} size="sm" />
                    Organization Management
                </DropdownItem>
            </a>

            <DropdownItem divider />

            {showSupportLink && (
                <a href={STATIC_URLS.SUPPORT} target="_blank" rel="noopener noreferrer">
                    <DropdownItem className="d-flex align-items-center py-1 px-2">
                        <FontAwesomeIcon className="mr-1" icon={faLifeRing} size="sm" />
                        Support
                    </DropdownItem>
                </a>
            )}

            <DropdownItem
                className="d-flex align-items-center py-1 px-2"
                onClick={handleLogout}
            >
                <FontAwesomeIcon className="mr-1" icon={faRightFromBracket} size="sm" />
                Logout
            </DropdownItem>
        </DropdownMenu>
    );
};

export default UserMenuItems;
